import { Col, Row, Skeleton } from 'ui';

const PersonalInfoSkeleton = () => (
  <Row gutter={['ms', 'xl']}>
    <Col span={24}>
      <Skeleton active paragraph={{ rows: 3 }} title={false} />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={12}>
      <Skeleton.Input active block />
    </Col>
    <Col span={20} />
    <Col span={4}>
      <Skeleton.Button active block />
    </Col>
  </Row>
);

export default PersonalInfoSkeleton;
